import React,{FunctionComponent} from 'react'
import PropTypes,{InferProps} from 'prop-types'
import {Navbar,Nav, Button,Container,Card,Row,ButtonGroup} from 'react-bootstrap'
// import * as d3 from 'd3'
import { FaPowerOff } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

import { SankeyNodePropTypes, SankeyLinkPropTypes, SankeyLabelPropTypes,SankeyDataPropTypes }  from 'open-sankey/dist/types'
import * as OpenSankeyUtils from 'open-sankey/dist/SankeyUtils'
import { logOutUser } from '../Login/LoginFunctions'


const DashboardPropTypes = {
  navbar_logo: PropTypes.string.isRequired,
  navbar_logo_width: PropTypes.number,
  navbar_app_version: PropTypes.string.isRequired,
  token:PropTypes.bool.isRequired,
  exemple_menu: PropTypes.object.isRequired,
  multi_selected_nodes: PropTypes.shape({current:PropTypes.arrayOf(PropTypes.shape(SankeyNodePropTypes).isRequired).isRequired}).isRequired,
  multi_selected_links: PropTypes.shape({current:PropTypes.arrayOf(PropTypes.shape(SankeyLinkPropTypes).isRequired).isRequired}).isRequired,
  multi_selected_label: PropTypes.shape({current:PropTypes.arrayOf(PropTypes.shape(SankeyLabelPropTypes).isRequired).isRequired}).isRequired,
  data: PropTypes.shape(SankeyDataPropTypes).isRequired,
  set_data: PropTypes.func.isRequired,
  unsetTokens: PropTypes.func.isRequired,
  useNavigate: PropTypes.func.isRequired,
  reinitialization:PropTypes.func.isRequired,
  set_user_scale:PropTypes.func.isRequired
}
type DashboardTypes = InferProps<typeof DashboardPropTypes>


// Dashboard, Register or Buy License
const Dashboard:FunctionComponent<DashboardTypes>=({
  navbar_logo, navbar_logo_width, navbar_app_version,
  token,
  exemple_menu,
  multi_selected_nodes,
  multi_selected_links,
  multi_selected_label,
  data, set_data,
  unsetTokens,
  useNavigate,reinitialization,set_user_scale})=>
{
  // Initialise traduction function
  const {t} = useTranslation()
  // Define navigation behaviour to return to App
  const navigate=useNavigate()
  const returnToApp=()=>{
    navigate('/')
    set_data({...data})
  }

  //If we acces this page without being logged, it is resent to the application
  if(!token){
    returnToApp()
  }

  //If we are log the the following behaviors are defined
  //Go to myAccount
  const myAccount=()=>{
    navigate('/account')
  }
  //Logout
  const loginOut=()=>{
    logOutUser(unsetTokens)
    returnToApp()
  }

  const tmp=JSON.parse(JSON.stringify(exemple_menu))
  let list_template_data=[] as string[]

  // Si exemple_menu contient OpenSankey et que ce sous dossier contient les templates simple alors remple la liste des templates avec les modèle simples
  if(Object.keys(tmp).length!==0 && Object.keys(tmp).includes('OpenSankey') && Object.keys(tmp['OpenSankey']).includes('easy_template') ){
    list_template_data=tmp['OpenSankey']['easy_template'].filter((f:string)=>!f.includes('.xlsx'))
  // Si l'un des sous dossier d'OpenSankey dans exemple_menu est expert_template alors ajoute les modèles expert à la liste des modèles
    if(token && Object.keys(tmp['OpenSankey']).includes('expert_template') ){
      list_template_data.push(tmp['OpenSankey']['expert_template'])
      list_template_data=list_template_data.flat()
    }
  }
  const modalTemplate=
  <>
    {list_template_data.map((_,idx) =>
    {
      const title=_.split('.').splice(0,1).join('')

      return(
        <Card>
          <Card.Img className='img-card' variant="top" src={'/fm/userfiles/OpenSankey/image_preview/'+title+'.png'} style={{'objectFit':'contain','maxHeight':'150px'}} />
          <Card.Body>
            <Card.Title>{_.split('_').join(' ')}</Card.Title>
            <ButtonGroup>
                <Button variant='primary'
                  onClick={() => {
                    multi_selected_nodes.current = []
                    multi_selected_links.current = []
                    multi_selected_label.current = []
                    const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                    OpenSankeyUtils.uploadExemple(
                      'OpenSankey/'+difficulty_file+'/'+list_template_data[idx], '/opensankey/', data, set_data,reinitialization,set_user_scale
                    )
                    navigate('/')
                    set_data({...data})
                  }

                  }
                >{t('useTemplate')}</Button>
                <Button variant='info'
                  onClick={() => {
                    multi_selected_nodes.current = []
                    multi_selected_links.current = []
                    multi_selected_label.current = []
                    const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                    OpenSankeyUtils.downloadExempleExcel(
                      'OpenSankey/'+difficulty_file+'/'+list_template_data[idx]
                    )
                  }

                  }
                >{t('dl')}</Button>
              </ButtonGroup>
          </Card.Body>
        </Card>
      )})}
  </>

  return(
    <div>
      <Navbar className='bg-light navbar-dashboard' fixed='top' style={{ 'display': 'block' }} >
        <Container className='MenuNavigation'>
          <Navbar.Brand href="/" rel="noopener noreferrer"><img src={navbar_logo} alt='navigation logo' width={navbar_logo_width ? navbar_logo_width : 200} /> {navbar_app_version} </Navbar.Brand>
          <Nav>
            <Nav.Item>
              <Button variant='light' onClick={()=>returnToApp()}>{t('UserPages.to_app')}</Button>
            </Nav.Item>
            <Nav.Item>
              <Button variant='light' onClick={()=>myAccount()}>{t('UserPages.to_acc')}</Button>
            </Nav.Item>
            <Nav.Item>
              <Button variant='danger' onClick={()=>loginOut()}><FaPowerOff/></Button>
            </Nav.Item>
          </Nav>
        </Container>
      </Navbar>

      <Card style={{'marginTop':'85px'}}>
        <Card.Header>{t('UserPages.win_db_template')}</Card.Header>
        <Card.Body>
          <Row md={4}>
            {modalTemplate}
          </Row>
        </Card.Body>
      </Card>

    </div>
  )
}

Dashboard.propTypes = DashboardPropTypes

export default Dashboard




